export default __webpack_public_path__ + "static/media/facility_05_1.cfb165e0.jpg";